import { router } from '~/router';
import axios from 'axios';
import { takeLatest } from 'redux-saga/effects';
import { apiRequest } from 'utils/request';
import { FULFILLED, LOGIN, LOGOUT } from './actionTypes';

export const logout = () => ({
    type: LOGOUT
});

// reducer
const INITIAL_STATE = {
    currentUserId: null,
    organizations: []
};

export default (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
        case LOGIN + FULFILLED:
            return {
                currentUserId: payload.id,
                organizations: payload.organizations
            };

        default:
            return state;
    }
};

function* logoutSaga() {
    try {
        yield apiRequest('/logout', 'POST');
        delete axios.defaults.headers.common['Authorization'];
        router.navigate('/login', { replace: true });
    } catch {
        delete axios.defaults.headers.common['Authorization'];
        router.navigate('/login', { replace: true });
    }
}

function* watchLogout() {
    yield takeLatest(LOGOUT, logoutSaga);
}

const sagas = [
    watchLogout
];

export { sagas };
